import logo from '../../../img/logo.svg';

export default function MobileLogo(){

    return (
        <header className="apply-mobile-logo">

            <img
                src={logo}
                width={220}
                height={58}
                alt="LearnyLib"
            />

        </header>
    );
}